const mEditionProductSatellitesIncluded = {
  mEditionProductSatellitesIncluded: {
    quote: {
      juedroop: {
        firstText: 'Todavía no hay satélites Juedroop disponibles para incluir.',
        secondText: 'Este producto todavía no incluye ningún Juedroop.',
        thirdText: 'Elegí un satélite Juedroop para venderlo junto a este producto.',
        fourthText: 'Solo podés incluir uno: al elegir otro, reemplaza al anterior.'
      },

      evaluacion: {
        firstText: 'Todavía no hay satélites de Evaluaciones disponibles para incluir.',
        secondText: 'Este producto todavía no incluye ningún satélite de Evaluaciones.',
        thirdText: 'Elegí un satélite de Evaluaciones para venderlo junto a este producto.',
        fourthText: 'Solo podés incluir uno: al elegir otro, reemplaza al anterior.'
      },

      ia_mensual: {
        firstText: 'Todavía no hay planes mensuales de Inteligencia Artificial disponibles para incluir.',
        secondText: 'Este producto todavía no incluye ningún plan mensual de IA.',
        thirdText: 'Elegí un plan mensual de IA para venderlo con este producto: el comprador recibe sus créditos el día de la compra y vuelven a estar completos el 1 de cada mes.',
        fourthText: 'Solo podés incluir uno: al elegir otro, reemplaza al anterior.'
      },

      ia_creditos: {
        firstText: 'Todavía no hay paquetes de créditos de Inteligencia Artificial disponibles para incluir.',
        secondText: 'Este producto todavía no incluye ningún paquete de créditos.',
        thirdText: 'Elegí un paquete de créditos de IA para venderlo con este producto: se paga una sola vez y sus créditos no vencen.',
        fourthText: 'Solo podés incluir uno: al elegir otro, reemplaza al anterior.'
      }
    },

    notAllowed: 'Solo los productos de la academia Vidroop pueden incluir satélites.',

    // El producto tiene planes que el satelite de ese tipo no admite (satelites/validacion?tipo=)
    incompatiblePlans: {
      juedroop: 'Este producto tiene planes de contado o en cuotas. Un producto con satélites se vende únicamente por suscripción mensual o anual: dá de baja esos planes en "Precios y Planes" para poder incluir uno.',
      evaluacion: 'Este producto tiene planes de contado o en cuotas. Un producto con satélites se vende únicamente por suscripción mensual o anual: dá de baja esos planes en "Precios y Planes" para poder incluir uno.',
      ia_mensual: 'Este producto tiene planes de contado o en cuotas. Un plan mensual de IA se vende únicamente por suscripción: dá de baja esos planes en "Precios y Planes" para poder incluir uno.',
      ia_creditos: 'Este producto tiene planes de suscripción o en cuotas. Un paquete de créditos se vende únicamente en un solo pago de contado: dá de baja esos planes en "Precios y Planes" para poder incluir uno.'
    },

    /*
     | La venta del satelite todavia no esta abierta (satelites/validacion: a_la_venta). Solo los tipos
     | que tienen texto aca pueden estarlo; el resto se vende siempre.
     */
    notForSale: {
      evaluacion: 'El Satélite Evaluaciones todavía no está disponible para la venta: su aula todavía no existe, así que nadie podría usarlo si lo compra. Vas a poder incluirlo en cuanto se publique.'
    },

    // Avisos que dependen del producto y no de sus planes. Solo los tipos que tienen texto aca lo
    // muestran: un paquete de creditos se vende solo, sin cursos ni mapas
    withAssets: {
      ia_creditos: 'Este producto incluye cursos o mapas. Un paquete de créditos se vende solo: si lo incluís, quitá los cursos y mapas en "Formaciones Incluidas".'
    },

    actions: {
      add: 'Incluir',
      remove: 'Quitar'
    },

    card: {
      type: {
        juedroop: 'SATÉLITE JUEDROOP',
        evaluacion: 'SATÉLITE EVALUACIONES',
        ia_mensual: 'PLAN MENSUAL DE IA',
        ia_creditos: 'PAQUETE DE CRÉDITOS DE IA'
      },
      included: 'Incluido',
      notIncluded: 'No Incluido',
      activo: 'Publicado',
      inactivo: 'No publicado'
    },

    // Lo que muestra el modal de cada tipo, con la clave del API en camelCase
    limites: {
      juedroop: {
        maximoJuegos: 'Juegos',
        maximoPreguntasPorJuego: 'Preguntas por juego',
        maximoJugadoresPorSala: 'Jugadores por sala',
        maximoJugadoresPorSalaEnVivo: 'Jugadores por sala en vivo',
        modoIndividual: 'Modo individual',
        modoEnVivo: 'Modo en vivo'
      },

      evaluacion: {
        maximoEvaluaciones: 'Evaluaciones',
        maximoPreguntasPorEvaluacion: 'Preguntas por evaluación',
        modoExamen: 'Modalidad examen',
        modoPractica: 'Modalidad práctica',
        modoAutoevaluacion: 'Autoevaluación',
        resultadosAnalitica: 'Resultados y analítica de alumnos',
        exportacionCsv: 'Exportación CSV'
      },

      ia_mensual: {
        creditos: 'Créditos por mes'
      },

      ia_creditos: {
        creditos: 'Créditos del paquete'
      }
    },

    search: 'Buscar',

    modal: {
      titleAdd: 'INCLUIR SATÉLITE',
      titleRemove: 'QUITAR SATÉLITE',
      caracteristicas: 'Características del satélite',
      sinDescripcion: 'Sin descripción',

      textAdd: 'Se incluirá el satélite',
      textRemove: 'Se quitará el satélite',

      replaceWarning: 'Este producto ya incluye {satelite}. Al confirmar, se reemplaza por el nuevo.',
      salesWarning: 'El cambio afecta a las ventas nuevas. Las licencias ya vendidas no se modifican.',

      // El producto tiene planes que el satelite de ese tipo no admite y por eso no puede incluirlo.
      // Cada tipo explica su regla de cobro: un Droop se vende solo por suscripcion, como un
      // producto Vidroop.
      blocked: {
        title: 'NO SE PUEDE INCLUIR TODAVÍA',
        buttonClose: 'ENTENDIDO',

        juedroop: {
          intro: 'Un producto que incluye satélites se vende únicamente por suscripción mensual o anual, igual que un producto Vidroop.',
          reason: 'Este producto todavía tiene planes de contado o en cuotas:',
          howTo: 'Andá a "Precios y Planes", dá de baja esos planes y volvé acá para incluir el satélite.'
        },

        evaluacion: {
          intro: 'Un producto que incluye satélites se vende únicamente por suscripción mensual o anual, igual que un producto Vidroop.',
          reason: 'Este producto todavía tiene planes de contado o en cuotas:',
          howTo: 'Andá a "Precios y Planes", dá de baja esos planes y volvé acá para incluir el satélite.'
        },

        ia_mensual: {
          intro: 'Un plan mensual de IA se vende únicamente por suscripción: sus créditos se renuevan todos los meses mientras se pague.',
          reason: 'Este producto todavía tiene planes de contado o en cuotas:',
          howTo: 'Andá a "Precios y Planes", dá de baja esos planes y volvé acá para incluir el plan de IA.'
        },

        ia_creditos: {
          intro: 'Un paquete de créditos se vende en un solo pago de contado: no admite suscripciones ni cuotas.',
          reason: 'Este producto todavía tiene planes de suscripción o en cuotas:',
          howTo: 'Andá a "Precios y Planes", dá de baja esos planes y volvé acá para incluir el paquete.'
        }
      },

      // Como se cobra lo que se esta por incluir. Solo los tipos con texto aca lo muestran en la
      // confirmacion
      cobro: {
        ia_mensual: 'Un plan mensual de IA se vende solo por suscripción mensual: el producto no puede ser gratis ni tener período de prueba.',
        ia_creditos: 'Un paquete de créditos se vende en un solo pago de contado: el producto no puede ser gratis, ni tener período de prueba, suscripciones o cuotas.'
      },

      // El backend rechazo la operacion y explica por que: se le muestra su mensaje tal cual,
      // en vez de la alerta generica que no decia nada
      failed: {
        titleAdd: 'NO SE PUDO INCLUIR',
        titleRemove: 'NO SE PUDO QUITAR',
        intro: 'La operación no se realizó. Esto es lo que informó el sistema:',
        fallback: 'No pudimos completar la operación. Volvé a intentarlo en un momento.',
        buttonClose: 'ENTENDIDO'
      },

      buttons: {
        cancel: 'CANCELAR',
        confirmAdd: 'INCLUIR',
        confirmRemove: 'QUITAR'
      }
    },

    alerts: {
      readSatelites: {
        error: 'No se pudieron cargar los satélites.'
      },

      updateProductoSatelites: {
        error: 'No se pudo actualizar el satélite del producto.',
        success: 'Satélites del producto actualizados.'
      }
    }
  }
}

export default mEditionProductSatellitesIncluded
